/* eslint-disable no-case-declarations */
import { createElement } from 'react'

// import sanitize from '@/lib/sanitize'
import linkResolver from './link-resolver'

// Function to add unique key to props
const propsWithUniqueKey = (props: any, key: any) => Object.assign(props || {}, { key })

// A11Y: Counter for unique fallback alt text when CMS alt is missing
let imageCounter = 0

// New API components object for @prismicio/react
const components = {
	image: ({ node }: any) => {
		imageCounter += 1
		const linkUrl = node.linkTo ? linkResolver(node.linkTo) : null
		const linkTarget =
			node.linkTo && node.linkTo.target ? { target: node.linkTo.target, rel: 'noopener' } : {}
		const wrapperClassList = [node.label || '', 'block-img']

		// A11Y: Use CMS alt if available, otherwise use counter for unique fallback
		const altText = node?.alt || `Article image ${imageCounter}`

		const img = (
			// eslint-disable-next-line @next/next/no-img-element
			<img
				src={node?.url || ''}
				alt={altText}
				// @ts-ignore FIXME: add `copyright` to img attributes type
				copyright={node?.copyright || ''}
			/>
		)

		const props = { className: wrapperClassList.join(' ') }
		const parsedChildren = linkUrl ? (
			<a href={linkUrl} {...linkTarget}>
				{img}
			</a>
		) : (
			img
		)

		return createElement('p', props, parsedChildren)
	},

	embed: ({ node }: any) => {
		const props = {
			'data-oembed': node.oembed.embed_url,
			'data-oembed-type': node.oembed.type,
			'data-oembed-provider': node.oembed.provider_name,
			className: 'video-embed',
			// dangerouslySetInnerHTML: { __html: sanitize(node.oembed.html) }
			dangerouslySetInnerHTML: { __html: node.oembed.html }
		}

		return createElement('div', props)
	},

	hyperlink: ({ node, children }: any) => {
		const target = node.data.target ? { target: node.data.target, rel: 'noopener' } : {}
		const hyperLinkUrl = linkResolver(node.data)
		const props = { target, href: hyperLinkUrl }

		return createElement('a', props, children)
	},

	label: ({ node, children }: any) => {
		if (node?.data?.label === 'blockquote') {
			return createElement('blockquote', {}, children)
		}

		const props = node.data.label ? { className: node.data.label } : { className: '' }
		return createElement('span', props, children)
	},

	// A11Y: Filter out empty headings from Prismic content
	// Empty headings fail WCAG - screen readers announce them but there's no content
	heading1: ({ children }: any) => {
		const hasContent = children?.some((child: any) =>
			typeof child === 'string' ? child.trim() : child
		)
		return hasContent ? createElement('h1', {}, children) : null
	},
	heading2: ({ children }: any) => {
		const hasContent = children?.some((child: any) =>
			typeof child === 'string' ? child.trim() : child
		)
		return hasContent ? createElement('h2', {}, children) : null
	},
	heading3: ({ children }: any) => {
		const hasContent = children?.some((child: any) =>
			typeof child === 'string' ? child.trim() : child
		)
		return hasContent ? createElement('h3', {}, children) : null
	},
	heading4: ({ children }: any) => {
		const hasContent = children?.some((child: any) =>
			typeof child === 'string' ? child.trim() : child
		)
		return hasContent ? createElement('h4', {}, children) : null
	},
	heading5: ({ children }: any) => {
		const hasContent = children?.some((child: any) =>
			typeof child === 'string' ? child.trim() : child
		)
		return hasContent ? createElement('h5', {}, children) : null
	},
	heading6: ({ children }: any) => {
		const hasContent = children?.some((child: any) =>
			typeof child === 'string' ? child.trim() : child
		)
		return hasContent ? createElement('h6', {}, children) : null
	}
}

export default components
